import { IsOptional, IsUUID } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

/**
 * DTO pour filtrer les groupes scolaires
 */
export class SchoolGroupQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par classe (UUID)',
  })
  @IsOptional()
  @IsUUID('4')
  classId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: "Filtrer par ID d'établissement",
  })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'ID du type de groupe pour filtrer',
  })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: "ID de l'année scolaire pour filtrer",
  })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string
}
